var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1764 8.7353L1.88232 10.6176L6.19863 2.67565C6.8926 1.39875 8.71034 1.35652 9.46286 2.59981L13.1764 8.7353Z",
    fill: "#EEC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58826 11.6176C6.58826 10.9171 7.13187 10.3493 7.80243 10.3493C8.473 10.3493 9.01661 10.9171 9.01661 11.6176C9.01661 12.3181 8.473 12.886 7.80243 12.886C7.13187 12.886 6.58826 12.3181 6.58826 11.6176Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84548 9.54008L6.64968 5.79008C6.63978 5.60054 6.78421 5.44116 6.96592 5.44116H8.63892C8.82063 5.44116 8.96509 5.60054 8.95519 5.79008L8.75939 9.54008C8.75023 9.71556 8.61134 9.85293 8.44312 9.85293H7.16174C6.99353 9.85293 6.85464 9.71556 6.84548 9.54008Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03346 3.1405C8.45914 2.10752 7.00741 2.13516 6.47236 3.19375L1.81626 12.4058C1.29544 13.4363 2.03981 14.6178 3.11093 14.6178H12.8887C13.9848 14.6178 14.729 13.3847 14.1552 12.3526L9.03346 3.1405ZM5.21239 2.55692C6.2569 0.490353 9.14141 0.429353 10.2673 2.45449L15.3891 11.6666C16.459 13.591 15.1166 16.0295 12.8887 16.0295H3.11093C0.934433 16.0295 -0.41492 13.6905 0.55629 11.769L5.21239 2.55692Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e2475514ebce49940cea9b69b1cf6fcc.svg";
export { ForwardRef as ReactComponent };